/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { CssTools } from './CssTools.js';
import { resolveCssColor } from './ColorTools.js';
/**
 * Builder to create the time-axis style.
 *
 * So far only horizontal time axes at the bottom of a chart are supported.
 */

export class TimeAxisBuilder {
  constructor() {
    this.title = null;
    this.tickLength = TimeAxisBuilder.TICK_LENGTH;
    this.tickLabelGap = TimeAxisBuilder.TICK_LABEL_GAP;
    this.fontFamily = null;
  }

  /**
   * Builds a style object for time axes
   */
  build() {
    // check that everything needed is set correctly
    if (this.fontFamily === null) {
      throw new Error('no font family set');
    }

    const style = {};
    style.tickFont = {
      family: this.fontFamily,
      size: CssTools.REM2PIXEL(TimeAxisBuilder.TICK_FONT_SIZE),
      style: 'normal',
      weight: 400 // regular

    };
    style.titleFont = {
      family: this.fontFamily,
      size: CssTools.REM2PIXEL(TimeAxisBuilder.TITLE_FONT_SIZE),
      style: 'normal',
      weight: 600 // semi-bold

    };
    style.axisSide = 'Bottom';
    style.tickLabelGap = CssTools.REM2PIXEL(this.tickLabelGap);
    style.tickLength = CssTools.REM2PIXEL(this.tickLength);
    style.tickLabelColor = resolveCssColor('var(--davinci-color-background-elements-5)');
    style.offsetTickLabelColor = resolveCssColor('var(--davinci-color-background-elements-5)');
    style.offsetAreaSize = CssTools.REM2PIXEL(TimeAxisBuilder.OFFSET_AREA_HEIGHT);
    style.offsetAreaTickLabelGap = CssTools.REM2PIXEL(TimeAxisBuilder.OFFSET_AREA_TICK_LABEL_GAP);
    style.offsetAreaFills = [resolveCssColor('var(--davinci-color-background-elements-1)'), resolveCssColor('var(--davinci-color-background-elements-2)')];
    style.axisLineColor = resolveCssColor('var(--davinci-color-background-elements-3)');
    style.axisLineWidth = TimeAxisBuilder.AXIS_LINE_WIDTH;
    style.title = this.title;
    style.titleGap = CssTools.REM2PIXEL(TimeAxisBuilder.TITLE_GAP);
    style.titleColor = resolveCssColor('var(--davinci-color-background-elements-4)');
    style.axisSize = this._computeAxisHeight();
    return style;
  }
  /**
   * Computes the height (horizontal) or width (vertical) of this value axis (in pixels).
   *
   * @returns the size of the value axis (in pixels)
   */


  _computeAxisHeight() {
    var _this$title;

    let axisHeight = TimeAxisBuilder.AXIS_LINE_WIDTH;
    axisHeight += CssTools.REM2PIXEL(this.tickLength);
    axisHeight += CssTools.REM2PIXEL(this.tickLabelGap);
    axisHeight += CssTools.REM2LINE_HEIGHT(1.0); // tick value label

    axisHeight += CssTools.REM2PIXEL(TimeAxisBuilder.OFFSET_AREA_HEIGHT);

    if (((_this$title = this.title) === null || _this$title === void 0 ? void 0 : _this$title.trim().length) > 0) {
      axisHeight += CssTools.REM2PIXEL(TimeAxisBuilder.TITLE_GAP);
      axisHeight += CssTools.REM2LINE_HEIGHT(1.0); // the title
    }

    return axisHeight;
  }

}
TimeAxisBuilder.AXIS_LINE_WIDTH = 1.0;
TimeAxisBuilder.OFFSET_AREA_HEIGHT = 1.5;
TimeAxisBuilder.OFFSET_AREA_TICK_LABEL_GAP = 0.25;
TimeAxisBuilder.TITLE_GAP = 0.25;
TimeAxisBuilder.TICK_LABEL_GAP = 0.25;
TimeAxisBuilder.TICK_LENGTH = 0.5;
TimeAxisBuilder.TITLE_FONT_SIZE = 0.75;
TimeAxisBuilder.TICK_FONT_SIZE = 0.75;
